var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dituContent-4",staticStyle:{"border":"#ccc solid 1px"},attrs:{"id":"dituContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }